export const LogEvents = {
	LOGIN: "1",
	LOGOUT: "2",
	DEMO: "3",
	SURVEY_STARTED: "4",
	SURVEY_FINISHED: "5",
	FEEDBACK_STARTED: "6",
	FEEDBACK_FINISHED: "7",
	DASHBOARD: "8",
	DEMO_LIST: "9",
	CALENDAR_LIST: "10",
	CALENDAR_EVENT: "11",
};

export const LogCompetitiveEvents = {
	LOGIN: "1",
	LOGOUT: "2",
	COMPETITOR: "3",
	COMPETITOR_PRODUCT: "4",
	RESOURCES: "5",
	FEEDBACK_STARTED: "6",
	FEEDBACK_FINISHED: "7",
	DASHBOARD: "8",
	RESOURCE_ADDED: "9",
	COMPETITOR_CREATED: "10",
	COMPETITOR_PRODUCT_ADDED: "11",
	SETTINGS_CHANGED: "12",
	SINGLE_CLICK_RESOURCE: "13",
	SINGLE_CLICK_RESOURCE_TYPE: "14"
}

export const LogCompetitiveAdminEvents = {
	LOGIN: "1",
	LOGOUT: "2",
	COMPETITOR: "3",
	COMPETITOR_PRODUCT: "4",
	RESOURCES: "5",
	FEEDBACK: "6",
	DASHBOARD: "7",
	SETTINGS_CHANGED: "8",
	SINGLE_CLICK_RESOURCE: "9",
	SINGLE_CLICK_RESOURCE_TYPE: "10",
}

export const LogAdminEventTypes = {
	ADD: "1",
	UPDATE: "2",
	DELETE: "3",
}

export const LogStorageEvents = {
	LOGIN: "1",
	LOGOUT: "2",
	APPLICATION: "3",
	APPLICATION_PRIMARY: "4",
	APPLICATION_LEVEL_2: "5",
}
